import React from 'react';
import { useSelector } from 'react-redux';
import LiveQuizPage from './LiveQuizPage';
import InviteLink from '../InviteGuests';
import './livequizpage.css';

const QuizCaseorgo = () => {
  const userDetails = useSelector((state) => state.userDetails);
  const user = userDetails?.user;

  // Derive the room number from user id
  const roomNumber = user ? user.id * 35 : null;

  if (!user) {
    return (
      <div className="outer-quiz-container">
        <div className="message">
          <h3>Error: User must be logged in to host a quiz!</h3>
          <p>Please sign in to continue.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="outer-quiz-container">
      <div className="game-intro-section">
        <div className="intro-header">
          <h1>Organic Chemistry Nomenclature Game</h1>
          <div className="intro-tagline">Test your knowledge of chemical structures and naming conventions</div>
        </div>
        
        <div className="intro-card">
          <div className="intro-card-header">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#3498db" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M12 8V12" stroke="#3498db" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <circle cx="12" cy="16" r="1" fill="#3498db"/>
            </svg>
            <h2>How to Play</h2>
          </div>
          
          <div className="intro-card-content">
            <p>Welcome to the Nomenclature Game! Test your knowledge of organic chemistry names and structures in an exciting, interactive way.</p>
            
            <div className="intro-steps">
              <div className="step">
                <div className="step-number">1</div>
                <div className="step-text">The host starts the game focused on organic chemistry nomenclature.</div>
              </div>
              
              <div className="step">
                <div className="step-number">2</div>
                <div className="step-text">Participants will join the game using a unique room code provided by the host.</div>
              </div>
              
              <div className="step">
                <div className="step-number">3</div>
                <div className="step-text">Each question will display a chemical structure, and players must identify its correct name.</div>
              </div>
              
              <div className="step">
                <div className="step-number">4</div>
                <div className="step-text">Points are awarded based on accuracy and speed. The faster you answer correctly, the more points you earn!</div>
              </div>
              
              <div className="step">
                <div className="step-number">5</div>
                <div className="step-text">At the end of the game, the player with the highest score wins!</div>
              </div>
            </div>
            
            <div className="intro-card-footer">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 15.5C14.21 15.5 16 13.71 16 11.5V6C16 3.79 14.21 2 12 2C9.79 2 8 3.79 8 6V11.5C8 13.71 9.79 15.5 12 15.5Z" stroke="#e74c3c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M4.34998 9.34998H7.64998C8.09998 9.34998 8.49998 9.74998 8.49998 10.2V12.8C8.49998 13.25 8.09998 13.65 7.64998 13.65H4.34998C3.89998 13.65 3.49998 13.25 3.49998 12.8V10.2C3.49998 9.74998 3.89998 9.34998 4.34998 9.34998Z" fill="#e74c3c"/>
                <path d="M19.65 9.34998H16.35C15.9 9.34998 15.5 9.74998 15.5 10.2V12.8C15.5 13.25 15.9 13.65 16.35 13.65H19.65C20.1 13.65 20.5 13.25 20.5 12.8V10.2C20.5 9.74998 20.1 9.34998 19.65 9.34998Z" fill="#e74c3c"/>
                <path d="M12 15.5V19.5" stroke="#e74c3c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M8 19.5H16" stroke="#e74c3c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <p>Good luck, and may the best chemist win!</p>
            </div>
          </div>
        </div>
        
        <div className="invite-section">
          <h3>Invite Players</h3>
          <p>Share the room code with other participants to join this quiz session</p>
          <InviteLink roomNumber={roomNumber} topics={[10]} />
        </div>
      </div>
      
      <div className="game-container">
        <LiveQuizPage topics={10} roomNumber={roomNumber} />
      </div>
    </div>
  );
};

export default QuizCaseorgo;
